<app-shared [type]="'inventaire'" [status]="'valide'"></app-shared>
